import React, { useEffect, useRef } from 'react'
import tex from '../../../Assets/Ground/marker.png'
import { useTexture } from '@react-three/drei'
import * as THREE from 'three'
import useStore from '../../StateStore/store'

const TeleportMarker = () => {
    const marker = useRef()

    const map = useTexture(tex)

    const teleportPosition = useStore(state => state.playerTeleport.position)
    const teleportState = useStore(state => state.playerTeleport.teleportState)

    useEffect(() => {
        if(teleportPosition){
            marker.current.position.set(teleportPosition.x, teleportPosition.y, teleportPosition.z)
            console.log(teleportPosition.y)
        }

        if(teleportState === false){
            marker.current.position.set(0, -10, 0)
        }
    }, [teleportPosition, teleportState])

    return (
        <mesh ref={marker} rotation={[Math.PI/2, 0, 0]} >
            <planeBufferGeometry args={[4,4]}/>
            <meshStandardMaterial map={map} transparent visible={teleportState} side={THREE.DoubleSide}/>
        </mesh>
    )
}

export default TeleportMarker
